<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Assets</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-card appearance="outlined" *ngIf="assetsFormArray.controls.length > 0 || (investmentFormArray && investmentFormArray.controls.length > 0)">
      <mat-card-content>
        <ng-container *ngIf="investmentFormArray">
        <div *ngFor="let asset of investmentFormArray.value; index as i">
          <ng-container *ngIf="!asset.isNewInvestment">
            <div class="row">
              <div class="col-sm-4" >
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <input matInput disabled placeholder="Type" value="Investment">
                  </mat-form-field>
                </div>
              </div>
              <div class="col-sm-4" >
                <mat-form-field appearance="outline">
                  <mat-label>Description</mat-label>
                  <input matInput disabled placeholder="Description" value="{{asset?.address?.fullAddress || asset.securityAddress?.fullAddress || asset.securityAddress?.flatSearch}}">
                </mat-form-field>
              </div>
              <div class="col-sm-2">
                <mat-form-field appearance="outline">
                  <mat-label>Amount</mat-label>
                  <input matInput disabled matInputCommified placeholder="Amount" value="{{asset.assetValue}}" min="0">
                  <span matPrefix>$&nbsp;</span>
                  <span matSuffix>.00</span>
                </mat-form-field>
              </div>
              <div class="col-sm-1 d-flex justify-content-start">
                <mat-checkbox [disabled]="true" [checked]="!!asset.refinancing" class="d-flex" >Refinance</mat-checkbox>
              </div>
              <div class="col-sm-1">

              </div>
            </div>
          </ng-container>
        </div>
        </ng-container>

        <div *ngFor="let asset of assetsFormArray.controls; index as i">
          <div class="row" [formGroup]="asset">
            <div class="col-sm-4" >
              <mat-form-field appearance="outline">
                <mat-label>Select a type</mat-label>
                <mat-select placeholder="Select a type" formControlName="type" (selectionChange)="handleAssetTypeChange(asset, $event.value, i)">
                  <ng-container>
                    <mat-option [disabled]="isSMSF && !type.ext?.isSMSF" *ngFor="let type of assetTypes" [value]="type.id">{{type.text}}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-4" *ngIf="asset.get('type').value === 'other'">
              <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <input matInput placeholder="Description" formControlName="description">
              </mat-form-field>
            </div>
            <div class="col-sm-2">
              <mat-form-field appearance="outline">
                <mat-label>Amount</mat-label>
                <input matInput placeholder="Amount" formControlName="amount" matInputCommified (change)="computeTotalAssets()" min="0">
                <span matPrefix>$&nbsp;</span>
                <span matSuffix>.00</span>
              </mat-form-field>
            </div>
            <div class="col-sm-1 d-flex justify-content-start" *ngIf="refinanceAssetTypes.includes(asset.value.type)">
              <mat-checkbox formControlName="refinance" class="d-flex" >Refinance</mat-checkbox>
            </div>
            <div class="col-sm-1">
              <button type="button" mat-icon-button (click)="removeAsset(i)" color="warn" *ngIf="removableFlags[i]"><mat-icon>delete</mat-icon></button>
            </div>
          </div>
          <app-ownership-allocation
            [allocationType]="'assets'"
            [personList]="personList"
            [companyList]="companyList"
            [trustList]="trustList"
            [formArray]="assetsFormArray"
            [formGroup]="asset"
            [isSMSF]="isSMSF">
          </app-ownership-allocation>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="row mt-4 d-flex">
      <div class="col-sm-8">
        <button mat-raised-button color="'primary'" type="button" name="addAsset" class="fmc-button-primary" (click)="addAsset(null)">Add New</button>
      </div>
      <div class="col-sm-4 justify-content-end">
        <mat-form-field appearance="outline">
          <mat-label>Total assets</mat-label>
          <input matInput placeholder="Total assets" formControlName="totalAssetsValue" matInputCommified readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <app-further-advance-confirmation
          *ngIf="isFurtherAdvance"
          [formGroup]="formGroup"
          [widgetName]="'app-assets-details'"
        ></app-further-advance-confirmation>
      </div>
    </div>
  </mat-card-content>
</mat-card>
